module.exports = __webpack_public_path__ + "img/footer_qr_wechat.40a0fdf7.jpg";